<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <!-- <v-toolbar-title class="white--text">{{toolbarTitle}}</v-toolbar-title> -->
		    <v-toolbar-title class="white--text" :class="{'two-line-title':Form.transactionTypeList && Form.transactionTypeList.length>1}">
		    	{{toolbarTitle}}
		    	<div class="toolbar-subtitle" @click="fn_openTransactionTypeList" v-if="Form.transactionTypeList && Form.transactionTypeList.length>1" >
		    		<div class="subtitle-text dark-opacity-color">{{Form.transactionTypeFormName ? Form.transactionTypeFormName : 'Select Transaction Form'}}</div>
		    		<v-icon class="subtitle-icon">arrow_drop_down</v-icon>
		    	</div>
		    </v-toolbar-title>

		    <!-- <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasBigFooterWithExtention grey-back" id="form" v-scroll="onScrollTransactionForm">

			<v-progress-linear height="4" nomargin indeterminate color="primary" v-if="loading"></v-progress-linear>

			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<div v-if="!loading">

				<v-alert style="height:42px" :value="true" color="warning pt-0 pb-0 pr-0" transition="slide-y-transition" v-if="transactionCount>=1">
	              <v-layout row wrap style="align-items:center">
	                <v-flex xs8 sm8 md8><v-icon class="font20 whitecolor mr-2">error_outline</v-icon> Set Auto Data Backup</v-flex>
	                <v-flex xs4 sm4 md4 right-align>
	                  <v-btn style="color:#fff" capitalize flat small @click="fn_gotoSetupDrive">Setup Now</v-btn>
	                </v-flex>
	              </v-layout>
	            </v-alert>
				<!-- <v-layout row wrap white-background padding-top-bottom-ten id="supplierfield" v-if="Form.transactionTypeList && Form.transactionTypeList.length>1">

					<v-flex xs12 sm12 md12 form-item @click="fn_openTransactionTypeList" id="transactionTypeField">
		               <v-text-field  
			               	readonly
			               	v-model="Form.transactionTypeFormName" 
			               	label="Transaction Form"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
			               	v-validate="'required'" 
		               		data-vv-name="transactionType" 
		               		data-vv-as="transaction type" 
		               		:error-messages="errors.collect('transactionType')"
		               		required>
		               </v-text-field>
		            </v-flex>

		        </v-layout> -->


				<v-layout row wrap :class="{'mt-2':Form.transactionTypeList && Form.transactionTypeList.length>1}">
				  <v-list full-width nopadding>
						  	<v-list-tile>
					          	<v-list-tile-content @click="fn_openDialogNumberSeries">
					              <!-- <v-list-tile-title>{{transactionNumber}}</v-list-tile-title> -->
					              <v-list-tile-title class="merged_tnumber">{{Form.transactionData.mergeTransactionNumber}}</v-list-tile-title>
					            </v-list-tile-content>

					            <span v-if="Form.transactionData.transactionDate">{{Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</span>	
		            			<span v-else>DD-MMM-YYYY</span>

					            <v-list-tile-action class="action-small">
		            				<v-btn flat icon color="primary" @click.native="fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker')" class="no-left-margin">

		            					<v-icon>date_range</v-icon>	
		            				</v-btn>
					            </v-list-tile-action>
						    </v-list-tile>
						</v-list>
				</v-layout>

				<v-layout row wrap margin-top-ten>
					<v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Particulars</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click.native="fn_openProductsDialog(true)" class="no-left-margin">
	            					Add
	            				</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>	
					</v-list>
				</v-layout>

				<v-divider v-if="Form.transactionProductsTemp.length"></v-divider>

				<v-list auto-height-tile nopadding>
					<div v-for="(item, index) in Form.transactionProductsTemp" :key="index" :class="{'invalid-item':item.invalidItem}">
						<v-list-tile class="right-subtitle-tile custom-action-tile">
						    <v-list-tile-content @click="fn_editGroup(item)">

						      <v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
						      	<v-list-tile-sub-title class="mb-1">
						      		<div>{{item.transactionProductMode ? 'Excess' : 'Short'}}</div>

						      		<div v-for="(vItem, vIndex) in item.variants" :key="vIndex" v-if="vItem.qty">
						      			&#8377; {{$root.numberToLocale(item.rate)}} X {{vItem.qty}} {{vItem.unitName}}
						      		</div>

						      		<!-- <span class="right_subtitle">&#8377; {{$root.numberToLocale(item.amount)}}</span> -->
						      		
						   		</v-list-tile-sub-title>
						      	
						      	<v-list-tile-sub-title v-if="$root.TransactionSettings.mrpWiseStock">
							      	<span>MRP: &#8377; {{$root.numberToLocale(item.mrp)}}</span>
						      	</v-list-tile-sub-title>
						    </v-list-tile-content>

						    <v-list-tile-action>

						    	<div>&#8377; {{$root.numberToLocale(item.amount)}}</div>

						    	<v-btn class="remove_btn" icon @click="fn_removeGroup(index)">
							      	<v-icon class="redcolor">remove_circle_outline</v-icon>
							    </v-btn>
						    	<!-- <v-menu>

							      <v-btn slot="activator" icon>
							      	<v-icon>more_vert</v-icon>
							      </v-btn>

							      <v-list nopadding>
							      	<v-list-tile @click="fn_editGroup(item)">
							        	<v-list-tile-title>Edit</v-list-tile-title>
							        </v-list-tile>
							        <v-divider></v-divider>
							        <v-list-tile @click="fn_removeGroup(index)">
							        	<v-list-tile-title>Remove</v-list-tile-title>
							        </v-list-tile>
							      </v-list>

							    </v-menu> -->
						    </v-list-tile-action>
						</v-list-tile>

						<v-divider v-if="Form.transactionProductsTemp.length-1 != index"></v-divider>
					</div>
				</v-list>

				<v-layout wrap margin-top-ten white-background v-if="Form.transactionProductsTemp.length">
					<v-list full-width nopadding>
					  	<v-list-tile>

					  		<v-list-tile-action v-if="Form.transactionData.notes">
				            	<v-btn icon @click="Form.transactionData.notes = ''">
						  			<v-icon>close</v-icon>
						  		</v-btn>
				            </v-list-tile-action>

				          	<v-list-tile-content full-width @click="fn_addNote">
				              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
							  <v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
				            </v-list-tile-content>
							
					    </v-list-tile>
					</v-list>

					<v-card full-width flat class="note-card" v-if="Form.transactionData.notes">
						<v-divider></v-divider>
					  	<v-card-text font16 v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</v-layout>

				<!-- <div id="note" v-if="Form.transactionData.notes" class="margin-top-ten">
					<v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click.native="fn_addNote" class="no-left-margin">
	            					Edit
	            				</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>

					<v-divider></v-divider>

					<v-card flat class="note-card">
					  <v-card-text v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</div> -->
			</div>	

		</v-form>

		<!-- <v-footer class="pa-3" fixed dark-grey>
	    	<v-layout row wrap>
	    	  <v-flex xs6 left-align>Short: &#8377; {{$root.numberToLocale(shortTotal)}}</v-flex>
	    	  <v-flex xs6 right-align>Excess: &#8377; {{$root.numberToLocale(excessTotal)}}</v-flex>
	    	</v-layout>
	    </v-footer> -->

	    <div white-background full-width nopadding style="position:fixed;bottom:0;">
			<v-layout row wrap>
				<template v-if="Form.transactionProductsTemp.length">
	    	  		<v-flex xs6 sm6 md6 pl-3 pt-2 pb-2 left-align>Short: &#8377; {{$root.numberToLocale(shortTotal)}}</v-flex>
	    	  		<v-flex xs6 sm6 md6 pr-3 pt-2 pb-2 right-align>Excess: &#8377; {{$root.numberToLocale(excessTotal)}}</v-flex>
				</template>
				<v-flex xs12 sm12 md12 height48>
					<v-btn color="primary" full-height nomargin block no-round-borders noshadow :disabled="disabledBtn" @click="fn_checkValidations">Save</v-btn>
				</v-flex>
			</v-layout>
		</div>

	   <!--  <v-dialog v-model="loading" no-click-animation no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog> -->

	    <dialog-note ref="ref_dialogNote"></dialog-note>
	    <dialog-number-series ref="ref_dialogNumberSeries" :checkTransactionNumber="fn_checkTransactionNumber"></dialog-number-series>
	    <!-- <dialog-date-picker ref="ref_dialogDatePicker" :minDate="minTransactionDate" :maxDate="maxTransactionDate" :updateDate="fn_updateDate"></dialog-date-picker> -->
		<dialog-date-picker ref="ref_dialogDatePicker" :updateDate="fn_updateDate"></dialog-date-picker>
	    <dialog-unit-groups ref="ref_dialogUnitGroups" :tpGroups="itemData.transactionProductGroups" :appendSection="fn_appendSection" :addMore="fn_addMore"></dialog-unit-groups>

	    <dialog-stock-journal ref="ref_dialogStockJournal" :isEdit="editParticular"></dialog-stock-journal>

	    <dialog-transaction-type-list ref="ref_dialogTransactionTypeList" :transactionTypeId="settings.transactionTypeId" :setTransactionType="fn_setTransactionType" :selectedTypeFormId="Form.transactionTypeFormId" :transactionTypeList="Form.transactionTypeList"></dialog-transaction-type-list>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations"></dialog-discard>

	    <!-- <dialog-confirmation ref="ref_dialogCancelTransaction" header="Cancel Transaction?" :confirmationMessage="confirmationMessage" :actionMethod="fn_callCancelTransaction"></dialog-confirmation> -->

	    <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items>

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	    <v-snackbar v-model="transactionNumberSnackbar" multi-line :timeout="0">
	    	Generate new transaction number?
	    	<v-btn flat icon @click="fn_bindTransactionNumber" color="primary">okay</v-btn>
	    	<v-btn flat icon @click="transactionNumberSnackbar=false">close</v-btn>
	    </v-snackbar>

	    <!-- <dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_gotoSetupDrive"></dialog-drive-alert> -->

	</div>
</template>

<script>
const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;
const transactionData = require('../../datamodel').data.transactionData;

const productGroupTypeId = require('../../../../config.js').configs.productGroupTypeId;

import dialogNote from '../dialogs/dialog_note'
import dialogNumberSeries from '../dialogs/dialog_number_series_manual'
import dialogDatePicker from './dialogs/dialog_datepicker'
import dialogUnitGroups from './dialogs/dialog_unit_groups'
import dialogStockJournal from './dialogs/dialog_stock_journal'
import dialogTransactionTypeList from '../dialogs/dialog_transaction_type_list'	//coming from outer dialogs folder
// import dialogConfirmation from '../../../dialogs/dialog_confirmation'
import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'
import {transactionMixin} from '../../transaction_mixin'
import dialogDraftItems from '../../../dialogs/dialog_draft_items'

// import dialogDriveAlert from '../dialogs/dialog_drive_alert'

	export default{
		props:['settings'],
		mixins: [draftMixin, transactionMixin],
		data(){
			return{

				Form:{
					"transactionData":JSON.parse(JSON.stringify(transactionData)),

					// "transactionProducts":[],
					"transactionProductsTemp":[],
					"trProducts":[],

					"productRefId":null,
					"itemName":null,
					"itemId":null,

					// "deletedTransactionProductIds":[],
					// "summary":'',
					"summaryArray":[],

					"transactionTypeFormId":null,
					"transactionTypeFormName":null,

					"transactionTypeData":null,

					"transactionProductModel":{transactionProductId:null, transactionId:null, productId :null, productVariantId:null, transactionProductMode:0, mrp:null, rate:null, additionalData:{}, groupId:null, variants:[], taxableValue:null},
					"transactionTypeList":[],
					"isNew":true,
					"draftItems":[]
				},

				// transactionProductModel:{transactionProductId:null, transactionId:null, productId :null, productVariantId:null, transactionProductMode:0, mrp:null, rate:null, additionalData:{}, groupId:null, variants:[]},

				loading:true,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,

				backButtonPress: false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,

				// loadedFromDraft:false,

				showFooter:true,
				// offsetTop:0,

				itemData:{transactionProductGroups:[]},
				productData:null,
				editParticular:false,
				confirmationMessage:null,
				toolbarTitle:"Stock Journal",
				transactionNumberSnackbar:false,
				disabledBtn:false
			}
		},
		components:{
			'dialog-note':dialogNote,
			'dialog-date-picker':dialogDatePicker,
			'dialog-unit-groups':dialogUnitGroups,
			'dialog-stock-journal':dialogStockJournal,
			'dialog-transaction-type-list': dialogTransactionTypeList,
			// 'dialog-confirmation':dialogConfirmation,
			'dialog-discard': dialogDiscard,
			'dialog-number-series': dialogNumberSeries,
			'dialog-draft-items': dialogDraftItems,
			// 'dialog-drive-alert':dialogDriveAlert
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     // this.fn_saveToLocalStorage(this);

                     let name = this.Form.transactionProductsTemp.length ? this.Form.transactionProductsTemp[0].productName : '';

                     if(!this.unwatch){
                     	this.fn_saveDraft(name);
                     }
                     this.unwatch = false;

                     let self = this;
                     if(this.Form.trProducts.length){
                     	this.Form.trProducts.forEach(function (item) {
                     		item.variants.forEach(function (vItem) {
                     			self.fn_itemTotal(vItem, item.rate);
                     		})	
                     	})
                     }
                 },
                 deep: true
            }
		},
		methods:{

			fn_openDialogNumberSeries: function(){
				this.transactionNumberSnackbar = false;
				this.fn_openDialogWeb('web', 'NumberSeries', 'ref_dialogNumberSeries')
			},

			// fn_callCancelTransaction: function(){
			// 	this.fn_closeDialog();
			// 	this.fn_cancelTransaction(this.Form.transactionData.transactionId, this.Form.transactionData.transactionListId, 'form');
			// },

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_getTransactionTypeList: function (setTFT) {
		        let filterObject = {};
		        filterObject.type = this.settings.transactionTypeId;

		        let self = this;
		        this.getItems("TransactionTypeList", filterObject, 
		          {
		            onSuccess: function (response) {
		              	console.log(response);

		              	self.Form.transactionTypeList = JSON.parse(response);

		              	setTFT ? self.fn_setLastSelectedTFT() : '';

		    //           	if(!self.loadedFromDraft && !self.Form.transactionData.transactionId){

		    //           		if(self.Form.transactionTypeList.length && !self.Form.transactionTypeFormId){

				  //             	if(localStorage.getItem(self.settings.transactionTypeId)){
				              		
				  //    				let transactionTypeFormId = localStorage.getItem(self.settings.transactionTypeId);

				  //             		for(let i=0; i<self.Form.transactionTypeList.length; i++){
				  //             			if(self.Form.transactionTypeList[i].transactionTypeFormId == transactionTypeFormId){
				  //             				self.fn_setTransactionType(self.Form.transactionTypeList[i]);
				  //             				break;
				  //             			}
				  //             		}   		              		
				  //             	}
				  //             	else{
				  //             		if(self.Form.transactionTypeList.length == 1){
						// 				self.fn_setTransactionType(self.Form.transactionTypeList[0]);
				  //             		}
				  //             	}

				  //           }
					
						// }     
		              
		            },
		            onError: function (error) {
		              console.log(error);
		            }
		          }
		        )
		    },

		    fn_setLastSelectedTFT: function(){
		    	if(localStorage.getItem(this.settings.transactionTypeId) && this.Form.transactionTypeList.length){
  					let transactionTypeFormId = localStorage.getItem(this.settings.transactionTypeId);

              		for(let i=0; i<this.Form.transactionTypeList.length; i++){
              			if(this.Form.transactionTypeList[i].transactionTypeFormId == transactionTypeFormId){
              				// this.fn_setTransactionType(this.Form.transactionTypeList[i], true);
              				this.fn_setTransactionType(this.Form.transactionTypeList[i]);
              				break;
              			}
              		}
  				}
  				else{
  					if(this.Form.transactionTypeList.length == 1){
  						// this.fn_setTransactionType(this.Form.transactionTypeList[0], true);	
  						this.fn_setTransactionType(this.Form.transactionTypeList[0]);	
  					}
  					else{
  						// this.loading = false;
  						// this.fn_openTransactionTypeList();
  						for(let i=0;i<this.Form.transactionTypeList.length; i++){
  							if(this.Form.transactionTypeList[i].isDefault){
  								this.fn_setTransactionType(this.Form.transactionTypeList[i]);
  								break;
  							}
  						}
  					}
              		// this.Form.transactionTypeList.length == 1 ? this.fn_setTransactionType(this.Form.transactionTypeList[0]) : '';
              	}
		    },

			fn_openTransactionTypeList: function () {
				this.fn_openDialogWeb('web', 'TransactionTypeList', 'ref_dialogTransactionTypeList');	
			},

			// fn_setTransactionType: function (item, openParty) {
			fn_setTransactionType: function (item) {
				let self = this;
				let transactionTypeSelected = this.Form.transactionTypeFormId ?  true : false;
				if(this.Form.transactionTypeFormId != item.transactionTypeFormId){

					// this.Form.dynamicFields = {"section":null, "items":[]};
					// this.Form.dynamicFieldsAdditionalData = {};
					// this.Form.customFields = [];
					// this.Form.dynamicMenuItems = [];

					this.fn_getTransactionTypeData(item.transactionTypeFormId, null, true);
				}

				this.Form.transactionTypeFormId = item.transactionTypeFormId;
				this.Form.transactionTypeFormName = item.name;

				localStorage.setItem(this.settings.transactionTypeId, item.transactionTypeFormId);

				this.errors.remove('transactionType');
				this.$forceUpdate();
				this.fn_closeDialog();

				if(!transactionTypeSelected && this.Form.draftItems && this.Form.draftItems.length){
					this.loading = false;
					this.fn_openDialogDraftItems();
				}

				// setTimeout(function(){
				// 	openParty ? self.fn_openCustomers() : '';
				// },300)
			},

			//updateNS = update number series
			fn_getTransactionTypeData: function(itemId, callback, updateNS){
				// this.showLoading('Please wait...');
				var self = this;
				// let transactionDate = this.Form.transactionData.transactionDate ? this.Form.transactionData.transactionDate : new Date();
				// let transactionDate = this.Form.transactionData.transactionDate ? this.Form.transactionData.transactionDate : this.$root.fn_getLocalDateFormat();
				if(new Date().getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
					this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(this.$root.CurrentBusiness.OpeningDate);
				}
				else{
					this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat();
				}

				let filterObject = {};
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(transactionDate));
				this.getFilterData('TransactionTypeForm', itemId, filterObject,
					{
						onSuccess: function(response){
				          console.log(response);
				          self.Form.transactionTypeData = JSON.parse(response);
				          self.fn_bindTransactionTypeData(callback, updateNS);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindTransactionTypeData: function (callback, updateNS) {
				updateNS && this.Form.isNew ? this.fn_bindTransactionNumber(updateNS) : '';

				let self = this;
				setTimeout(function(){
					self.$root.fn_copyFormObject(self.Form, self.formId);
				},500);
				// this.hideLoading();
				this.loading = false;
			},

			// fn_bindTransactionNumber: function () {

			// 	this.transactionNumberSnackbar = false;

			// 	let numberSeriesData = this.Form.transactionTypeData.numberSeries;

			// 	this.Form.transactionData.prefix = numberSeriesData.prefix;
			// 	this.Form.transactionData.suffix = numberSeriesData.suffix;
			// 	// this.Form.transactionData.transactionNumber = numberSeriesData.nextNumber;

			// 	//For reference use only as incrementing transaction number by numberSeries id in transaction number
			// 	this.Form.transactionData.numberSeriesId = numberSeriesData.numberSeriesId;

			// 	this.Form.transactionData.transactionNumberId = numberSeriesData.transactionNumberId

			// 	let self = this;

			// 	// this.getData('TransactionNumber', numberSeriesData.numberSeriesId, 
			// 	this.getData('TransactionNumber', numberSeriesData.transactionNumberId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				let data = JSON.parse(response);
			// 				self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
			// 				self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
			// 	        }, 
			// 	        onError: function(error){
			// 	          	console.log(error);
			// 	        }
			// 		}
		 //        );
				
			// },

			fn_bindTransactionNumber: function () {

				if(!this.Form.transactionTypeData){
					return;
				}

				this.transactionNumberSnackbar = false;

				let numberSeriesData = this.Form.transactionTypeData.numberSeries;

				this.Form.transactionData.prefix = numberSeriesData.prefix;
				this.Form.transactionData.suffix = numberSeriesData.suffix;

				//For reference use only as incrementing transaction number by numberSeries id in transaction number
				this.Form.transactionData.numberSeriesId = numberSeriesData.numberSeriesId;

				// this.Form.transactionData.transactionNumberId = numberSeriesData.transactionNumberId;

				let filterObject = {};
				filterObject.numberSeriesId = numberSeriesData.numberSeriesId;
				// filterObject.transactionNumberId = numberSeriesData.transactionNumberId;
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));

				let self = this;

				this.getFilterData('TransactionNumber', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
							self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
							self.Form.transactionData.transactionNumberId = data.transactionNumberId;
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
				
			},

			fn_editGroup: function (item) {
				this.fn_getProductData(item.productId, item.variants);

				if(this.Form.transactionData.transactionId){
					// this.fn_pushVariants(item.variants);
					let self = this;
					item.variants.forEach(function (item) {
						self.fn_getLabel(item.unitName, item.packQuantity, function (label) {
			          		item.label = label;
			          	});
					})
				}
				this.Form.trProducts = [];
				this.Form.itemId = item.productId;
				this.Form.itemName = item.productName;
				// this.editParticular = true;
				this.Form.trProducts.push(item);
				this.fn_addParticulars(true);
			},

			fn_removeGroup: function (index) {
				// let self = this;
				// if(this.Form.transactionData.transactionId){
				// 	this.Form.transactionProductsTemp[index].variants.forEach(function (item) {
				// 		let obj = {};
				// 		obj.transactionProductId = item.transactionProductId;
				// 		self.Form.deletedTransactionProductIds.push(obj);
				// 	})	
				// }
				this.Form.transactionProductsTemp.splice(index, 1);
			},

			fn_getGroupTotal: function (tp) {
				let total = 0;
				tp.variants.forEach(function (item) {
					total += item.amount;
				});

				tp.amount = total;
			},

			// fn_itemTotal: function (item, rate) {
			// 	let packQty = 1;

			// 	item.packQuantity ? packQty = item.packQuantity : '';

			// 	if(!item.qty || !rate)
			// 		item.amount = 0;
			// 	else{
			// 		item.amount = item.qty * packQty * rate;
			// 	}
			// },

			fn_addParticulars: function (isEdit) {
				this.editParticular = isEdit;
				this.fn_openDialogWeb('web', 'StockJournal', 'ref_dialogStockJournal');
			},

			fn_openTransactionProductGroups: function (transactionProductGroups) {
				if(!transactionProductGroups.length){
					this.fn_addMore();
				}
				else if(transactionProductGroups.length==1){
					this.fn_appendSection(transactionProductGroups[0], true);
				}
				else{
					// this.fn_openDialogWeb('web', 'UnitGroups', 'ref_dialogUnitGroups')
					this.$root.TransactionSettings.mrpWiseStock ? this.fn_openDialogWeb('web', 'UnitGroups', 'ref_dialogUnitGroups') : this.fn_appendSection(transactionProductGroups[0], true);
				}
			},
			fn_updateDate: function (value) {
				// this.Form.transactionData.transactionDate = value;
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
				// this.Form.isNew ? this.fn_bindTransactionNumber() : '';
				this.fn_closeDialog();
			},
			fn_focusItem: function (event) {
				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo(event.target, self.scrollOptions);
				},300);
			},

			// onScroll: function (e) {
			// 	this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
			// },

			fn_removeItem: function (tIndex, variants) {
				// if(this.Form.transactionData.transactionId){
				// 	for(let i=0;i<variants.length;i++){
				// 		let obj = {};
				// 		obj.transactionProductId = variants[i].transactionProductId;
				// 		this.Form.deletedTransactionProductIds.push(obj);
				// 	}
				// }
				this.Form.trProducts.splice(tIndex, 1);
			},

			fn_openProductsDialog: function (isAddNew) {
				if(isAddNew){
					this.Form.itemId = null;
					this.Form.itemName = null;
					this.Form.trProducts = [];
					this.itemData.transactionProductGroups = [];
				}
				this.fn_openProductList('android', 'ProductList', 'ref_fieldProductName')
			},

			fn_openProductList: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";
				viewDialogObject.groupTypeId = productGroupTypeId.product;
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.inventory = 1;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.itemId && this.Form.itemName){
					paramObject.defaultValue = {"id":this.Form.itemId, "name":this.Form.itemName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
			},

			fn_updateProductName: function (selectedValueId, selectedValueName, isRemoved) {
				let isOpen = false;
				if(!isRemoved){
					if(this.Form.itemId){
						isOpen = true;
					}

					if(this.Form.itemId != selectedValueId){
						this.Form.trProducts = [];
						this.itemData.transactionProductGroups = [];
						this.fn_getTransactionProducts(selectedValueId, isOpen);
						this.fn_getProductData(selectedValueId);
						// isOpen = true;
					}

					this.Form.itemId = selectedValueId;
		        	this.Form.itemName = selectedValueName;
					
				}

				this.$forceUpdate();
			},

			fn_itemTotal: function (item, rate) {
				let packQty = 1;

				item.packQuantity ? packQty = item.packQuantity : '';

				if(!item.qty || !rate)
					item.amount = 0;
				else{
					let amount = item.qty * packQty * rate;
					item.amount = this.roundUpto2Decimals(amount);
				}

				item.taxableValue = item.amount;
			},

			fn_addMore: function (closeDialog) {
				this.Form.transactionProductModel.groupId = null;
				this.Form.transactionProductModel.productId = this.Form.itemId;
				this.Form.transactionProductModel.productName = this.Form.itemName;
				this.Form.transactionProductModel.mrp = this.productData.mrp;
				let item = JSON.parse(JSON.stringify(this.Form.transactionProductModel));
				this.Form.trProducts.push(item);
				closeDialog ? this.fn_closeDialogWeb() : '';
			},

			fn_clearModel: function () {
				this.Form.transactionProductModel = {"transactionProductId":null, "transactionId":null, "productId" :null, "productVariantId":null, "mrp":null, "rate":null, "additionalData":{}, "variants":[]};
			},

			fn_getSummary: function (itemId) {
				var self = this;
				this.getData('ProductSummary', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							let str = '';
							self.Form.summaryArray = JSON.parse(response);
							
							console.log(str);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getProductData: function (itemId, itemVariants) {
				var self = this;
				this.getData('Product', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.productData = JSON.parse(response);
				          	self.fn_getSummary(itemId);

				          	self.fn_pushVariants(self.productData.productVariants);

				          	itemVariants ? self.fn_refreshUnits(self.productData.productVariants, itemVariants) : '';

				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_refreshUnits: function (productVariants, variants) {
          		if(variants.length != productVariants.length){

					for(var j in productVariants){
					   	var shared = false;

					   	for (var k in variants){
					   		if (variants[k].productVariantId == productVariants[j].productVariantId) {
					           shared = true;
					           break;
					       }
					   	}
					       
					   	if(!shared){
					   		let variantObj = {};

				          	let uName = productVariants[j].unitName;
				          	let pQty = productVariants[j].packQuantity

				          	variantObj.unitName = productVariants[j].unitName;
				          	variantObj.unitId = productVariants[j].unitId;
				          	variantObj.packQuantity = productVariants[j].packQuantity;
				          	variantObj.productId = productVariants[j].productId;
				          	variantObj.productVariantId = productVariants[j].productVariantId;

				          	variantObj.qty = null;
				          	variantObj.amount = null;

				          	this.fn_getLabel(uName, pQty, function (label) {
				          		variantObj.label = label;
				          		variants.splice(j, 0, variantObj);
				          	});
					   	} 
					}

				}
			},

			fn_getTransactionProducts: function (itemId, isOpen) {
				
				let filterObject = {};
				// filterObject.endDate = new Date();
				filterObject.endDate = this.$root.fn_getLocalDateFormat();

				let self = this;
				this.getFilterData('ItemGroupsByMRP', itemId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							if(data.transactionProductGroups){
								self.itemData.transactionProductGroups = data.transactionProductGroups;	
							}
							else{
								self.itemData.transactionProductGroups = [];
							}
							
							if(isOpen){
				          		setTimeout(function () {
				          			self.fn_openTransactionProductGroups(data.transactionProductGroups);
				          		},300);
				          	}
				          	else{
				          		let openDialogs = setInterval(function(){
				    				var dialogData = JSON.parse(localStorage.getItem(self.dialogStorageId));
				    				if(!dialogData){
				    					self.fn_addParticulars(false);
				    					setTimeout(function () {
				    						self.fn_openTransactionProductGroups(data.transactionProductGroups);
				    					},300);
				    					clearInterval(openDialogs);
				    				}
						        },50);
				          	}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
				

				// this.getData('ItemGroupsByMRP', itemId, 
				// 	{
				// 		onSuccess: function(response){
				// 			console.log(response);
				// 			let data = JSON.parse(response);
				// 			if(data.transactionProductGroups){
				// 				self.itemData.transactionProductGroups = data.transactionProductGroups;	
				// 			}
				// 			else{
				// 				self.itemData.transactionProductGroups = [];
				// 			}


							
							
				// 			if(isOpen){
				//           		setTimeout(function () {
				//           			self.fn_openTransactionProductGroups(data.transactionProductGroups);
				//           		},300);
				//           	}
				//           	else{
				//           		let openDialogs = setInterval(function(){
				//     				var dialogData = JSON.parse(localStorage.getItem(self.dialogStorageId));
				//     				if(!dialogData){
				//     					self.fn_addParticulars();
				//     					setTimeout(function () {
				//     						self.fn_openTransactionProductGroups(data.transactionProductGroups);
				//     					},300);
				//     					clearInterval(openDialogs);
				//     				}
				// 		        },50);
				//           	}
				//         }, 
				//         onError: function(error){
				//           console.log(error);
				//         }
				// 	}
		  //       );
			},

			fn_appendSection: function (item, singleItemAppend) {
				let tpObj = {};


				tpObj.groupId = null;

				tpObj.mrp = item.mrp;

				tpObj.rate = item.rate;

				tpObj.transactionProductMode = 0;

				tpObj.productId = item.variants[0].productId;

				tpObj.productName = item.variants[0].productName;

				tpObj.variants = [];

				let self = this;

				this.productData.productVariants.forEach(function (vItem) {
					let vObj = {};
					vObj.unitId = vItem.unitId;
					vObj.primaryUnitId = vItem.variantBaseUnitId;
					vObj.unitName = vItem.unitName;
					vObj.packQuantity = vItem.packQuantity;
					vObj.qty = null;
					vObj.amount = 0;
					vObj.productId = vItem.productId;
					vObj.productName = self.productData.name;
					vObj.productVariantId = vItem.productVariantId;
					vObj.groupId = null;
					tpObj.variants.push(vObj);
				})

				this.Form.trProducts.push(tpObj);
				this.fn_bindLabels(this.Form.trProducts);
				!singleItemAppend ? this.fn_closeDialogWeb() : '';
			},

			fn_pushItem: function () {
				// this.Form.trProducts.forEach(function (item) {
				// 	self.Form.transactionProductsTemp.push(item);		
				// })

				// let itemExist = false;
				// let groupIndexes = [];

				for(let i=0; i<this.Form.trProducts.length; i++){
					let tp = this.Form.trProducts[i];
					if(tp.hasQuantity){

						!tp.mrp ? tp.mrp = 0 : '';
						!tp.rate ? tp.rate = 0 : '';

						this.fn_getGroupTotal(tp);

						if(tp.groupId){
							let itemIndex = this.Form.transactionProductsTemp.findIndex(item => item.groupId==tp.groupId);
							// this.Form.transactionProductsTemp[itemIndex] = JSON.parse(JSON.stringify(tp));
							tp.invalidItem = false;
							this.Form.transactionProductsTemp.splice(itemIndex, 1, tp);
						}
						else{
							tp.groupId = this.guid();
							this.Form.transactionProductsTemp.push(tp);
						}
					}
				}

				// this.Form.transactionProductsTemp = JSON.parse(JSON.stringify(this.Form.trProducts));
				// for(let i=0; i<this.Form.trProducts.length; i++){
				// 	let tP = this.Form.trProducts[i];

				// 	for(let j=0; j<tP.variants.length; j++){

				// 		let variant = tP.variants[j];

				// 		let tpObj = {};

				// 		if(variant.qty){

				// 			!variant.transactionProductId ? tpObj.transactionProductId = this.guid() : tpObj.transactionProductId = variant.transactionProductId;

				// 			tpObj.transactionId = this.Form.transactionData.transactionId;

				// 			tpObj.productId = variant.productId;

				// 			tpObj.productName = variant.productName;

				// 			tpObj.productVariantId = variant.productVariantId;

				// 			tpObj.groupId = tP.groupId;

				// 			tpObj.mrp = tP.mrp;

				// 			tpObj.rate = tP.rate;

				// 			tpObj.additionalData = null;

				// 			tpObj.unitId = variant.unitId;

				// 			tpObj.unitName = variant.unitName;

				// 			tpObj.qty = variant.qty;

				// 			tpObj.packQuantity = variant.packQuantity;

				// 			tpObj.amount = variant.amount;

				// 			tpObj.transactionProductMode = tP.transactionProductMode;

				// 			!tP.transactionProductMode ? tpObj.actualQty = -variant.qty : tpObj.actualQty = variant.qty;

				// 			this.Form.transactionProducts.push(tpObj);

				// 		}
				// 		else{
				// 			if(this.Form.transactionData.transactionId){
				// 				let obj = {};
				// 				obj.transactionProductId = variant.transactionProductId;
				// 				this.Form.deletedTransactionProductIds.push(obj);
				// 			}
				// 		}

				// 	}

				// }

				this.fn_closeDialogWeb();
			},

			fn_refreshSummary: function (productVariants) {

				var summaryArray = JSON.parse(JSON.stringify(this.Form.summaryArray));

				for(var i in productVariants){
				   	var shared = false;
				   	for (var j in summaryArray){
				   		if (summaryArray[j].unitId == productVariants[i].unitId) {
				           shared = true;
				           break;
				       	}
				  	}
				   	if(!shared){
				   		let obj = {};
						obj.unitId = productVariants[i].unitId;
						obj.unitName = productVariants[i].unitName;
						obj.qty = 0;
						// this.Form.summaryArray.push(obj)
						this.Form.summaryArray.splice(i, 0, obj);
				   	} 
				}
			},

			// fn_refreshUnits: function (productVariants) {

			// 	let self = this;

			// 	this.fn_pushVariants(productVariants);

			// 	if(productVariants.length > this.Form.summaryArray.length){
			// 		this.fn_refreshSummary(productVariants);
			// 	}

			// 	let trp = this.Form.trProducts;

			// 	let variantsToAdd = [];

			// 	for(let i=0; i<trp.length; i++){

			// 		let variants = JSON.parse(JSON.stringify(trp[i].variants));

			// 		if(variants.length != productVariants.length){

			// 			for(var j in productVariants){
			// 			   	var shared = false;

			// 			   	for (var k in variants){
			// 			   		if (variants[k].productVariantId == productVariants[j].productVariantId) {
			// 			           shared = true;
			// 			           break;
			// 			       }
			// 			   	}
						       
			// 			   	if(!shared){
			// 			   		let variantObj = {};

			// 		          	let uName = productVariants[j].unitName;
			// 		          	let pQty = productVariants[j].packQuantity

			// 		          	variantObj.unitName = productVariants[j].unitName;
			// 		          	variantObj.unitId = productVariants[j].unitId;
			// 		          	variantObj.packQuantity = productVariants[j].packQuantity;
			// 		          	variantObj.productId = productVariants[j].productId;
			// 		          	variantObj.productVariantId = productVariants[j].productVariantId;

			// 		          	variantObj.qty = null;
			// 		          	variantObj.amount = null;

			// 		          	this.fn_getLabel(uName, pQty, function (label) {
			// 		          		variantObj.label = label;
			// 		          		trp[i].variants.splice(j, 0, variantObj);
			// 		          	});
			// 			   	} 
			// 			}
			// 		}

			// 	}

			// },

			// fn_bindProduct: function (productData) {
			// 	this.Form.trProducts = [];
			// 	this.transactionProductModel.variants = [];
	          	
	  //         	let mrp = null;
	  //         	let self = this;

	  //         	this.fn_pushVariants(productData.productVariants, function (mrp) {
	  //         		let item = JSON.parse(JSON.stringify(self.transactionProductModel));
			// 		self.Form.trProducts.push(item);
			// 		self.Form.trProducts[0].mrp = mrp;
	  //         	});

	  //         	productData.productVariants.filter(item=>{
	  //         		let obj = {};
	  //         		obj.unitId = item.unitId;
	  //         		obj.unitName = item.unitName;
	  //         		obj.qty = 0;
	  //         		self.Form.summaryArray.push(obj);
	  //         	})
			// },
			
			// fn_pushVariants: function (variants, callback) {
			fn_pushVariants: function (variants) {
				let mrp = null;
				this.Form.transactionProductModel.variants = [];
				for(let i=0;i<variants.length;i++){

		          	let variantObj = {};

		          	// variants[i].isDefault ? mrp = variants[i].mrp : '';

		          	let uName = variants[i].unitName;
		          	let pQty = variants[i].packQuantity

		          	this.fn_getLabel(uName, pQty, function (label) {
		          		variantObj.label = label	
		          	});

		          	variantObj.unitName = variants[i].unitName;
		          	variantObj.unitId = variants[i].unitId;
		          	variantObj.primaryUnitId = variants[i].variantBaseUnitId;
		          	variantObj.packQuantity = variants[i].packQuantity;
		          	variantObj.productId = variants[i].productId;
		          	variantObj.productVariantId = variants[i].productVariantId;

		          	variantObj.qty = null;
		          	variantObj.amount = 0;

		          	this.Form.transactionProductModel.variants.push(variantObj);
		        }

		   //      if(callback!=undefined){
					// callback(mrp);
		   //      }
			},

			fn_getLabel: function (uName, pQty, cb) {
				let label = null
				if(pQty){
	          		label = uName + ' ('+pQty+')';
	          	}
	          	else{
	          		label = uName;
	          	}

	          	cb(label);
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialogWeb: function () {
				this.editParticular = false;
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				// this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				this.fn_updateProductName(selectedValueId, selectedValueName, isRemoved);
			},

			fn_getBottomMenu: function (tagId) {
				let bottomMenu = null;

				let menuItem_Note = null;
				!this.Form.transactionData.notes ? menuItem_Note = menuItem.addNote : menuItem_Note = menuItem.editNote;

				bottomMenu = {"BottomMenu": [menuItem.save, menuItem_Note,  menuItem.reset]};

				// this.Form.transactionData.transactionId ? bottomMenu.BottomMenu.unshift(menuItem.cancelTransaction) : '';

				// if(this.Form.transactionData.transactionId){
				// 	bottomMenu = {"BottomMenu": [menuItem.save, menuItem_Note, menuItem.reset, menuItem.help]};
				// }

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				this.disabledBtn = true;
				this.showLoading('Please Wait...');
				this.$validator.validateAll().then((result) => {
			        if (result) {
			        	if(this.Form.transactionProductsTemp.length){
							// this.fn_post();
							let self = this;
							this.fn_checkTransactionNumber(function(){
				        		self.fn_post();
				        	});
						}
						else{
							// this.snackbar = true;
							// this.snackbar_msg = "Add minimum 1 particular."
							this.disabledBtn = false;
							this.showToast("Add particulars");
							this.hideLoading();
						}
			    	}
			    	else{
			    		this.disabledBtn = false;
			    		this.hideLoading();
			    	}
			    });
			},

			fn_checkTransactionNumber: function(callback){
				var self = this;
				let filterObject = {};
				filterObject.mergeTransactionNumber = this.Form.transactionData.mergeTransactionNumber;
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				filterObject.typeId = this.settings.transactionTypeId;
				let transactionId = this.Form.transactionData.transactionId ? this.Form.transactionData.transactionId : null;
				this.getFilterData('CheckTransactionNumber', transactionId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							callback ? callback() : '';
				        }, 
				        onError: function(error){
				        	self.disableBtn = false;
				          	console.log(error);
				          	self.showToast('Transaction number already exists');
				          	self.hideLoading();
				          	self.transactionNumberSnackbar = true;
				        }
					}
		        );
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('TransactionProducts', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.fn_cleanUp();
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				          	let response = JSON.parse(error);
				         	if(response && response.negativeProducts && response.negativeProducts.length){
				         		self.fn_shortListInvalidItems(response.negativeProducts);
				         	}
				        }
					}
		        );
			},

			fn_shortListInvalidItems: function(negativeProducts){
				for(let i=0; i<this.Form.transactionProductsTemp.length; i++){
					for(let j=0; j<negativeProducts.length; j++){
						// if(this.Form.items[i].productId == negativeProducts[j].productId && this.Form.items[i].mrp == negativeProducts[j].mrp){
						if(this.Form.transactionProductsTemp[i].groupId == negativeProducts[j].groupId){
							this.Form.transactionProductsTemp[i].invalidItem = true;
							this.$forceUpdate();
							break;
						}
					}
				}

				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo('.invalid-item', self.scrollOptions);
					self.showToast("These items are not in stock");
				},100)
			},

			fn_cleanUp: function () {
				// this.loadedFromDraft = false;
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.hideLoading();
					// self.$router.go(-1);
					self.fn_previewInvoice(false, "inventory", 'sj');
				});
			},

			fn_post: function(){

				//only in case of new transaction
				if(!this.Form.transactionData.transactionId){
					this.Form.transactionData.transactionId = this.guid();
					// this.Form.transactionData.createdDate = new Date();
					this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
					//random transaction number just for now
					// this.Form.transactionData.transactionNumber = 'TN/'+this.randomFourCharString();
					this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
				}

				// this.Form.transactionData.modifiedDate = new Date();
				this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.transactionData.amount = this.roundUpto2Decimals(this.totalAmount);
				this.Form.transactionData.roundedAmount = Math.round(this.totalAmount);
				this.Form.transactionData.status = 1;
				this.Form.transactionData.transactionTypeFormId = this.Form.transactionTypeFormId;
				this.Form.transactionData.refDate = null;

				// this.Form.transactionProducts = [];
				let transactionProducts = [];

				for(let i=0; i<this.Form.transactionProductsTemp.length; i++){
					let tP = this.Form.transactionProductsTemp[i];

					for(let j=0; j<tP.variants.length; j++){

						let variant = tP.variants[j];

						let tpObj = {};

						if(variant.qty){

							!variant.transactionProductId ? tpObj.transactionProductId = this.guid() : tpObj.transactionProductId = variant.transactionProductId;

							tpObj.transactionId = this.Form.transactionData.transactionId;

							tpObj.productId = variant.productId;

							tpObj.productVariantId = variant.productVariantId;

							tpObj.groupId = tP.groupId;

							// tpObj.mrp = tP.mrp ? tP.mrp : null;

							// tpObj.rate = tP.rate ? tP.rate : null;

							tpObj.mrp = tP.mrp;

							tpObj.rate = tP.rate;

							tpObj.additionalData = null;

							tpObj.unitId = variant.unitId;

							tpObj.primaryUnitId = variant.primaryUnitId;

							tpObj.qty = variant.qty;

							tpObj.packQuantity = variant.packQuantity ? variant.packQuantity : 1;

							tpObj.amount = variant.amount;

							tpObj.taxableValue = variant.taxableValue;

							tpObj.transactionProductMode = tP.transactionProductMode;

							!tP.transactionProductMode ? tpObj.actualQty = -variant.qty : tpObj.actualQty = variant.qty;

							// this.Form.transactionProducts.push(tpObj);
							transactionProducts.push(tpObj);

						}
						// else{
						// 	if(this.Form.transactionData.transactionId){
						// 		let obj = {};
						// 		obj.transactionProductId = variant.transactionProductId;
						// 		this.Form.deletedTransactionProductIds.push(obj);
						// 	}
						// }

					}

				}

				let postObj = {};

				postObj = this.Form.transactionData;
				postObj.transactionProducts = transactionProducts//this.Form.transactionProducts;
				// postObj.deletedTransactionProductIds = this.Form.deletedTransactionProductIds;

				//check for negative stock
				postObj.checkNegative = this.$root.TransactionSettings.disableNegativeStock;
				postObj.checkNegativeAsPerMrp = this.$root.TransactionSettings.disableNegativeStock && this.$root.TransactionSettings.mrpWiseStock;
				postObj.isNew = this.Form.isNew;

				postObj.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');
				
				console.log(this.Form);
				this.fn_saveLocal(postObj);
			},

			// fn_deleteItem: function(itemId){
			// 	var self = this;
			// 	this.deleteData('TransactionAndProduct', itemId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				self.fn_goBack();
			// 	        }, 
			// 	        onError: function(error){
			// 	          console.log(error);
			// 	        }
			// 		}
		 //        );
			// },

			fn_getData: function (type, itemId) {
				this.Form.isNew = false;
				let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;

				let self = this;
				this.getFilterData(type, itemId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.fn_bindingData(data);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			// fn_get: function(type, itemId){
			// 	var self = this;
			// 	this.getData(type, itemId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);

			// 				let data = JSON.parse(response);

			// 				self.fn_bindingData(data);

			// 				// if(response){
			// 				// 	self.itemData = JSON.parse(response);
			// 				// 	setTimeout(function () {
			// 				// 		self.fn_openTransactionProductGroups();
			// 				// 	},300);
			// 				// 	// self.fn_bindData(item);
			// 				// }
			// 				// else{
			// 				// 	self.fn_clearForm();
			// 				// 	type=='TransactionProductsOfProduct' ? self.fn_getProductData(itemId) : '';
			// 				// }

			// 	        }, 
			// 	        onError: function(error){
			// 	          console.log(error);
			// 	        }
			// 		}
		 //        );
			// },

			fn_bindingData: function (data) {
				this.fn_getTransactionTypeData(data.transactionTypeFormId, null, false);
				this.Form.transactionData.additionalData = data.additionalData;
				this.Form.transactionData.amount = data.amount;
				this.Form.transactionData.businessId = data.businessId;
				this.Form.transactionData.createdBy = data.createdBy;
				this.Form.transactionData.createdDate = data.createdDate;
				this.Form.transactionData.currencyId = data.currencyId;
				this.Form.transactionData.dueDate = data.dueDate;
				this.Form.transactionData.dueType = data.dueType;
				this.Form.transactionData.modifiedBy = data.modifiedBy;
				this.Form.transactionData.modifiedDate = data.modifiedDate;
				this.Form.transactionData.notes = data.notes;
				this.Form.transactionData.partyId = data.partyId;
				this.Form.transactionData.paymentMode = data.paymentMode;
				this.Form.transactionData.prefix = data.prefix;
				this.Form.transactionData.refDate = data.refDate;
				this.Form.transactionData.refNumber = data.refNumber;
				this.Form.transactionData.roundedAmount = data.roundedAmount;
				this.Form.transactionData.salesmanId = data.salesmanId;
				this.Form.transactionData.status = data.status;
				this.Form.transactionData.suffix = data.suffix;
				this.Form.transactionData.transactionDate = data.transactionDate;
				this.Form.transactionData.transactionId = data.transactionId;
				this.Form.transactionData.transactionListId = data.transactionListId;
				this.Form.transactionData.transactionNumber = data.transactionNumber;
				this.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
				this.Form.transactionProductsTemp = JSON.parse(JSON.stringify(data.transactionProducts));

				this.Form.transactionTypeFormId = data.transactionTypeFormId;
				this.Form.transactionTypeFormName = data.transactionTypeFormName;

				this.Form.transactionData.numberSeriesId = data.numberSeriesId;
				this.Form.transactionData.transactionNumberId = data.transactionNumberId;

				let self = this;
				this.Form.transactionProductsTemp.forEach(function (item) {
					item.transactionProductMode = item.variants[0].transactionProductMode;
					self.fn_getGroupTotal(item);
				});

				setTimeout(function(){
					self.$root.fn_copyFormObject(self.Form, self.formId);
				},500);

				// this.fn_getTransactionTypeData(data.transactionTypeFormId, function (args) {
					
				// 	console.log(args);

				// 	if(data.customFields && data.customFields.length){
				// 		data.customFields.forEach(function (item) {
				// 			item.items.forEach(function (fieldItem) {
				// 				fieldItem.additionalData = JSON.parse(fieldItem.additionalData);
				// 				fieldItem.fieldType = JSON.parse(fieldItem.fieldType);
				// 			});
				// 		});

				// 		self.Form.customFields = JSON.parse(JSON.stringify(data.customFields));
				// 	}

				// });
			},

			// fn_getSummary: function (itemId) {
			// 	var self = this;
			// 	this.getData('OpeningStockSummaryOfTransaction', itemId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				let str = '';
			// 				self.Form.summaryArray = JSON.parse(response);
							
			// 				console.log(str);
			// 	        }, 
			// 	        onError: function(error){
			// 	          console.log(error);
			// 	        }
			// 		}
		 //        );
			// },

			// fn_bindData: function (item) {
			// 	this.unwatch = true;
			// 	this.Form.transactionData.amount = this.itemData.amount;
			// 	this.Form.transactionData.createdDate = this.itemData.createdDate;
			// 	this.Form.transactionData.modifiedDate = this.itemData.modifiedDate;
			// 	this.Form.transactionData.roundedAmount = this.itemData.roundedAmount;
			// 	this.Form.transactionData.status = this.itemData.status;
			// 	this.Form.transactionData.transactionDate = this.itemData.transactionDate;
			// 	this.Form.transactionData.transactionId = this.itemData.transactionId;
			// 	this.Form.transactionData.transactionListId = this.itemData.transactionListId;
			// 	this.Form.transactionData.transactionNumber = this.itemData.transactionNumber;
			// 	this.Form.transactionData.notes = this.itemData.notes;

			// 	this.Form.productRefId = this.itemData.productId;
			// 	this.Form.itemId = this.itemData.productId;
			// 	this.Form.itemName = this.itemData.productName;

			// 	this.Form.trProducts.push(item)

			// 	this.fn_bindLabels(this.Form.trProducts);

			// 	// this.fn_pushVariants(this.Form.trProducts[0].variants);

			// 	// let self = this;
			// 	// setTimeout(function () {
			// 	// 	let htmlElement = document.getElementsByClassName(self.$route.query.groupId)[0];
			// 	// 	self.$vuetify.goTo(htmlElement, self.scrollOptions);
			// 	// },300);

			// 	this.fn_getSummary(this.Form.transactionData.transactionId);

			// 	this.fn_closeDialogWeb();
			// },

			fn_appendItem: function () {
				
			},

			fn_bindLabels: function (items) {
				let self = this;
				for(let i = 0; i < items.length; i++){
					for(let j = 0; j < items[i].variants.length; j++){
						(function (i, j) {
							let uName = items[i].variants[j].unitName;
							let pQty = items[i].variants[j].packQuantity;
							self.fn_getLabel(uName, pQty, function (label) {
								items[i].variants[j].label = label;
							});
						}(i, j))
					}
				}
			},

			fn_clearForm: function(){
				this.unwatch = true;
				this.Form.transactionData = JSON.parse(JSON.stringify(transactionData));
				// this.Form.transactionProducts = [];
				this.Form.transactionProductsTemp = [];
				this.Form.trProducts = [];
				this.Form.productRefId = null;
				this.Form.itemName = null;
				this.Form.itemId = null;
				this.Form.transactionTypeFormId = null;
				this.Form.transactionTypeFormName = null;
				this.Form.transactionTypeData = null;

				this.Form.transactionProductModel = {transactionProductId:null, transactionId:null, productId :null, productVariantId:null, transactionProductMode:0, mrp:null, rate:null, additionalData:{}, groupId:null, variants:[], taxableValue:null}

				this.Form.transactionTypeList = [];
				this.Form.draftItems = [];

				this.$validator.reset();

				this.fn_getTransactionTypeList(true);
			},

			// fn_saveToLocalStorage: function(){
			// 	if(!this.unwatch){
			// 		var dataObj = {};
			// 		dataObj.type = "Stock Journal";
			// 		dataObj.formType = "new";
			// 		dataObj.modifiedDate = new Date();
			// 		dataObj.formId = this.formId;
			// 		dataObj.draftId = this.draftStorageId;
			// 		dataObj.uri = this.$route.path;
			// 		dataObj.dataModel = this.Form;
			// 		dataObj.dataModel.name = "no name";

			// 		if(this.Form.transactionProductsTemp.length){
			// 			dataObj.dataModel.name = this.Form.transactionProductsTemp[0].productName;
			// 		}

			// 		localStorage.setItem(this.draftStorageId, JSON.stringify(dataObj));
			// 	}
			// 	this.unwatch = false;
			// },

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
				else if(menuAction=='addnote'){
					this.fn_addNote();
				}
				// else if(menuAction=='cancel'){
				// 	this.fn_openDialogCancelTransaction();
				// }
			},

			// fn_openDialogCancelTransaction: function(){
			// 	this.confirmationMessage = "Cancelled transaction cannot be revoke."
			// 	this.fn_openDialogWeb('web', 'Cancel Transaction', 'ref_dialogCancelTransaction');
			// },

			fn_addNote: function () {
				this.$refs['ref_dialogNote'].noteValue = this.Form.transactionData.notes;
				this.fn_openDialogWeb('web', 'Note', 'ref_dialogNote');
				setTimeout(function(){
					let noteField = document.getElementById('noteField');
					noteField.focus();
				});
			},

			fn_saveNote: function () {
				this.Form.transactionData.notes = this.$refs['ref_dialogNote'].noteValue;
				this.fn_closeDialog();
				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo('#note', self.scrollOptions);
				},300);
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;
				if(this.Form.transactionData.transactionId){
					this.fn_getData('TransactionProducts', this.Form.transactionData.transactionId);;
				}
				else{
					this.fn_clearForm();
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					// self.snackbar = true;
					// self.snackbar_msg = "Item deleted from draft";
					self.showToast("Item deleted from draft");
				});
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			// fn_setFormDataFromLocalStorage: function () {
			// 	if(localStorage.getItem(this.draftStorageId)){
			// 		var formData = JSON.parse(localStorage.getItem(this.draftStorageId));
			// 		this.Form.transactionData = JSON.parse(JSON.stringify(formData.dataModel.transactionData));
			// 		this.Form.transactionProducts = JSON.parse(JSON.stringify(formData.dataModel.transactionProducts));
			// 		this.Form.transactionProductsTemp = JSON.parse(JSON.stringify(formData.dataModel.transactionProductsTemp));
			// 		this.Form.trProducts = JSON.parse(JSON.stringify(formData.dataModel.trProducts));
			// 		this.Form.productRefId = formData.dataModel.productRefId;
			// 		this.Form.itemName = formData.dataModel.itemName;
			// 		this.Form.itemId = formData.dataModel.itemId;
			// 		this.Form.transactionProductModel = formData.dataModel.transactionProductModel;

			// 		this.Form.transactionTypeFormId = formData.dataModel.transactionTypeFormId;
			// 		this.Form.transactionTypeFormName = formData.dataModel.transactionTypeFormName;
			// 		this.Form.transactionTypeData = JSON.parse(JSON.stringify(formData.dataModel.transactionTypeData));
					

			// 		if((this.$route.query && this.$route.query.draft) || (this.$route.params && this.$route.params.tagId)){
			// 			this.loadedFromDraft = true;
			// 			!this.Form.transactionData.transactionId ? this.fn_bindTransactionNumber() : '';
			// 		}
			// 	}
				
			// },

			fn_setData: function (formData) {
				let data = JSON.parse(formData);
				this.Form.transactionData = JSON.parse(JSON.stringify(data.transactionData));
				// this.Form.transactionProducts = JSON.parse(JSON.stringify(data.transactionProducts));
				this.Form.transactionProductsTemp = JSON.parse(JSON.stringify(data.transactionProductsTemp));
				this.Form.trProducts = JSON.parse(JSON.stringify(data.trProducts));
				this.Form.productRefId = data.productRefId;
				this.Form.itemName = data.itemName;
				this.Form.itemId = data.itemId;
				this.Form.transactionProductModel = data.transactionProductModel;

				this.Form.transactionTypeFormId = data.transactionTypeFormId;
				this.Form.transactionTypeFormName = data.transactionTypeFormName;
				this.Form.transactionTypeData = JSON.parse(JSON.stringify(data.transactionTypeData));

				!this.Form.transactionData.transactionId ? this.fn_bindTransactionNumber() : '';
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "transactionTypeForm":
					    	this.fn_setTransactionType({transactionTypeFormId:itemData.id, name:itemData.name});
					        break;
					    case "product":
					    	this.fn_updateProductName(itemData.id, itemData.name, false);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			// this.Form.transactionData.transactionNumber = 'TN/'+this.randomFourCharString();

			// this.Form.trProducts.push(this.transactionProductModel);

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
				// !this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive") ?  this.fn_checkTransactionCount() : '';
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			!this.$root.CurrentBusiness.DataDrive ?  this.fn_checkTransactionCount() : '';

			var formsArray = [];
			if(localStorage.getItem('stockjournalforms')){
				formsArray = JSON.parse(localStorage.getItem('stockjournalforms'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('stockjournalforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}
			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				var self = this;
				this.unwatch = true;
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.fn_setData(draft.formData);

						// if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
						// 	self.loadedFromDraft = true;
						// }
						// else{
						// 	self.loading = false;
						// }

						self.loading = false;
					}

		            self.$route.query.tagId ? self.fn_checkDraftItems(self.toolbarTitle) : '';

				});
			}

			this.unwatch = true;
			// this.Form.isNew ? this.Form.transactionData.transactionDate = new Date() : '';
			this.Form.isNew ? this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat() : '';

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('Transaction', this.toolbarTitle);

		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(from.name=='stockJournalItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//checking if draft exist
		  		vm.fn_isDraft(function(isDraft){
		  			if(itemId && !isDraft){
		  				vm.fn_getData('TransactionProducts', itemId);
		  			}

		  			let setTFT = !itemId && !isDraft;

		  			vm.fn_getTransactionTypeList(setTFT);
		  		})

		  	})
		},
		beforeRouteUpdate (to, from, next) {
			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('stockjournalforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					this.backButtonPress = false;
					next(false);
				}
				else{
					localStorage.removeItem("SetDataDrive");
					// this.$root.fn_deleteFormObject();
					next(true);
				}
			}
			else{
				// if(this.askToDiscard){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				if(this.fn_showDialogDiscard()){
					if(this.Form.isNew && !this.Form.transactionProductsTemp.length){
						this.fn_clearData('salesforms', function(){
							localStorage.removeItem("SetDataDrive");
							next();
						})
					}
					else{
						this.fn_openDialogDiscard();
						next(false);	
					}
				}
				else{
					this.fn_clearData('salesforms', function(){
						localStorage.removeItem("SetDataDrive");
						next();
					})
				}
				// if(this.loadedFromDraft ||  (!this.quitForm && this.Form.partyName && (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId)))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.quitForm ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	localStorage.removeItem('stockjournalforms');
				// 	localStorage.removeItem("SetDataDrive");
				// 	next();	
				// }
			}
	    },
	    computed:{
	    	totalAmount: function () {
	    		return this.excessTotal - this.shortTotal
	    		// let amount = 0;

	    		// this.shortTotal = 0;
	    		// this.excessTotal = 0;

	    		// let self = this;
	    		// this.Form.transactionProductsTemp.forEach(function (item) {
	    		// 	amount += item.amount;
	    		// 	item.transactionProductMode ? self.excessTotal += item.amount : self.shortTotal += item.amount;
	    		// });
	    		// return amount;
	    	},
	    	excessTotal: function () {
	    		let total = 0;
	    		this.Form.transactionProductsTemp.forEach(function (item) {
	    			item.transactionProductMode ? total += item.amount : '';
	    		});
	    		return total;
	    	},
	    	shortTotal: function () {
	    		let total = 0;
	    		this.Form.transactionProductsTemp.forEach(function (item) {
	    			!item.transactionProductMode ? total += item.amount : '';
	    		});
	    		return total;
	    	},
	    	// minTransactionDate: function(){
	    	// 	if(!this.Form.isNew){
	    	// 		let defaultMinDate = new Date(this.$root.minDateSelection);
	    	// 		let month = ("0" + (defaultMinDate.getMonth() + 1)).slice(-2);
	    	// 		// let date = defaultMinDate.getDate();
	    	// 		let date = ("0" + defaultMinDate.getDate()).slice(-2);
	    	// 		return this.fn_getFiscalYear(this.Form.transactionData.transactionDate) + "-" + month + "-" + date;
	    	// 	}
	    	// 	else{
	    	// 		return null;
	    	// 	}
	    	// },
	    	// maxTransactionDate: function(){
	    	// 	if(!this.Form.isNew){
	    	// 		return (this.fn_getFiscalYear(this.Form.transactionData.transactionDate)+1) + "-03-31";
	    	// 	}
	    	// 	else{
	    	// 		return null;
	    	// 	}
	    	// }
	    	
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_journal/form.vue